import { decodeMultiApp } from '../../../solaris-lens-common-lib/src/utils/multiApp';
import { MULTI_APP_PARAM } from '../constants/multiApp';

/**
 * Reads and decodes multiApp params from a location search string.
 * Used by any receiving app after redirect (OIDC-only, classic-only, or both).
 * @param {string} [search=window.location.search]
 * @returns {{ multiApp: string, encodedMultiApp: string }}
 */
export const getMultiAppParamsFromLocation = (
  search = typeof window !== 'undefined' ? window.location.search : ''
) => {
  const params = new URLSearchParams(search);
  const encodedMultiApp = params.get(MULTI_APP_PARAM) || '';

  if (!encodedMultiApp) {
    return {
      encodedMultiApp: '',
      multiApp: ''
    };
  }

  try {
    return {
      encodedMultiApp,
      multiApp: decodeMultiApp(encodedMultiApp)
    };
  } catch (error) {
    console.error('Failed to decode multiApp param', error);
    return {
      encodedMultiApp,
      multiApp: ''
    };
  }
};
